export const namespaced = true;

export const actions = {
    async activate({ commit, dispatch }, key) {
        try {
            const res = (await axios.post('/api/admin/licenses', { key })).data;
            const notification = {
                type: 'success',
                message: res.message
            }
            dispatch('notification/add', notification, { root: true });
            location.reload();
        } catch (error) {
            let message = error.response && error.response.data && error.response.data.message;
            if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.error) {
                message += `<br>${error.response.data.errors.error}`
            }
            const notification = {
                type: 'error',
                message
            }
            dispatch('notification/add', notification, { root: true })
        }
    }
}
